import _ from 'lodash';
import customFilterColumnsExtend from '../../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../../admin_entities/walk/step_record_detail.js';
import { shareColumnsExtend } from '../share';
const filterColumns = {
  device_id_cont: {
    model_name: 'Walk::StepRecord',
    column_type: 'string',
    column_name: 'deviceId',
  },
  is_active_eq: {
    column_type: 'boolean',
    model_name: 'Walk::StepRecord',
    column_name: 'isActive',
  },
  miapay_wallet_holder_id_eq: {
    column_type: 'belongs_to',
    column_name: 'miapay_wallet_holder',
    extra: {
      model_name: 'Miapay::WalletHolder',
    },
    model_name: 'Walk::StepRecord',
  },
  miapay_wallet_holder: {
    column_type: 'belongs_to',
    column_name: 'miapay_wallet_holder',
    extra: {
      model_name: 'Miapay::WalletHolder',
    },
    model_name: 'Walk::StepRecord',
  },
  miapay_wallet_holder_phone_cont: {
    model_name: 'Miapay::WalletHolder',
    column_type: 'string',
    column_name: 'phone',
  },
  date_gteq: {
    model_name: 'Walk::StepRecord',
    column_type: 'string',
    column_name: 'date',
  },
  date_lteq: {
    model_name: 'Walk::StepRecord',
    column_type: 'string',
    column_name: 'date',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Walk::StepRecord', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Walk::StepRecord', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
